import { computed, inject, Injectable, signal } from '@angular/core';
import { take } from 'rxjs';
import { ApiService } from '../api/api.service';
import { ItemRadioDataExtended } from '../../components/dynamic-form/models/dynamic-form.models';
import { ProceduresState } from '../../models/core/shared-state.models';

@Injectable({
  providedIn: 'root'
})
export class SharedStateService {
  private readonly apiService = inject(ApiService);

  // Listado de procedimientos
  public static readonly ProceduresState = signal<ProceduresState>({
    loading: true,
    procedures: []
  });
  // Listado de procedimientos formateados para el formulario dinámico
  public static readonly ProceduresDynamicFormState = computed<ItemRadioDataExtended[]>(() =>
    SharedStateService.ProceduresState().procedures.map((proc) => ({
      value: proc.code,
      text: `${proc.code} - ${proc.name}`
    }))
  );
  // Comprueba que las configuraciones minimas se hayan cargado
  public static readonly ConfigsLoaded = computed(() => !SharedStateService.ProceduresState().loading);

  onLoginLoadStates() {
    this.getProcedures();
  }

  /**
   * Obtiene la lista de procedimientos desde el servicio correspondiente y actualiza el estado compartido.
   *
   * - Establece el estado inicial con `loading: true` y una lista vacía de procedimientos.
   * - Realiza una solicitud al servicio `proceduresService` para obtener los procedimientos.
   * - Si la solicitud es exitosa, actualiza el estado compartido con los procedimientos obtenidos y `loading: false`.
   * - Si ocurre un error, actualiza el estado compartido con `loading: false` y una lista vacía de procedimientos.
   *
   */
  private getProcedures() {
    SharedStateService.ProceduresState.set({ loading: true, procedures: [] });
    this.apiService
      .getProcedures()
      .pipe(take(1))
      .subscribe({
        next: (procedures) => {
          SharedStateService.ProceduresState.set({ loading: false, procedures: procedures.data });
        },
        error: () => {
          SharedStateService.ProceduresState.set({ loading: false, procedures: [] });
        }
      });
  }
}
